import React from "react";
import { t } from "ttag";

import { FormView } from "../FormView";
import { IPhone } from "../models";

interface IProps {
    phone: Partial<IPhone>;
}

export const CustomerDetailsPhone = (props: IProps) => {
    return (
        <FormView
            url={props.phone.url}
            baseURL={"/api/csr/user-phones/"}
            fields={[
                {
                    name: "user",
                    type: "hidden",
                },
                {
                    label: t`Phone Number`,
                    name: "phone_number",
                    placeholder: t`+1 (555) 555-5555`,
                    isRequired: true,
                    type: "phone",
                },
            ]}
            initialValues={props.phone}
        />
    );
};
